// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compact-limit-modal {
  max-width: 380px;
}
.compact-limit-modal .limit-icon {
  font-size: 2rem;
  margin-bottom: 0.75rem;
}
.compact-limit-modal h3 {
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
}
.compact-limit-modal .limit-message {
  font-size: 0.9rem;
  margin-bottom: 1rem;
}
.compact-limit-modal .limit-message-small {
  font-size: 0.85rem;
  margin-top: 0.75rem;
  margin-bottom: 1rem;
  opacity: 0.8;
}
.compact-limit-modal .limit-stats-compact {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: #f5f5f5;
  border-radius: 6px;
  font-size: 0.9rem;
}
.compact-limit-modal .limit-stats-compact .stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}
.compact-limit-modal .limit-stats-compact .stat-item .stat-label {
  font-size: 0.75rem;
  opacity: 0.7;
  text-transform: uppercase;
}
.compact-limit-modal .limit-stats-compact .stat-item .stat-value {
  font-weight: 600;
  font-size: 1.1rem;
}
.compact-limit-modal .limit-stats-compact .stat-divider {
  font-size: 1.25rem;
  opacity: 0.3;
  margin: 0 0.25rem;
}
.compact-limit-modal .limit-actions-compact {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}
.compact-limit-modal .limit-actions-compact .limit-btn {
  flex: 1 1;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}
.compact-limit-modal .limit-actions-compact .limit-btn.secondary {
  background: #e0e0e0;
  color: #333;
}
.compact-limit-modal .limit-actions-compact .limit-btn.secondary:hover {
  background: #d0d0d0;
}
.compact-limit-modal .limit-actions-compact .limit-btn.primary {
  background: #1976d2;
  color: white;
}
.compact-limit-modal .limit-actions-compact .limit-btn.primary:hover {
  background: #1565c0;
}

.date-range-inputs {
  display: block !important;
  margin-top: 15px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  background-color: #f9f9f9;
}
.date-range-inputs .date-input-group {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.date-range-inputs .date-input-group:last-child {
  margin-bottom: 0;
}
.date-range-inputs .date-input-group label {
  min-width: 80px;
  font-weight: 500;
  color: #333;
}
.date-range-inputs .date-input-group input[type=date] {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  flex: 1 1;
}

.detailsection-dashboard-wrapper {
  padding: 10px;
}
.detailsection-dashboard-wrapper .invoice-export-modal {
  padding: 0px;
  text-align: left;
  min-width: 500px;
  max-width: 600px;
  background: #fff;
  border-radius: 12px;
}
.detailsection-dashboard-wrapper .invoice-export-modal h3 {
  margin: 0 0 8px 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  text-align: center;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-subtext {
  margin: 0 0 25px 0;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  text-align: center;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 60vh;
  overflow-y: scroll;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  background: #f8f9fa;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-title {
  margin: 0 0 15px 0;
  font-size: 16px;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 8px;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option:hover {
  background: #e9ecef;
  border-color: #ced4da;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option input[type=radio] {
  margin: 0;
  width: 16px;
  height: 16px;
  accent-color: var(--primary-color);
  cursor: pointer;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option .filter-label {
  font-size: 14px;
  color: #495057;
  font-weight: 500;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option:has(input:checked) {
  background: #e7f3ff;
  border-color: var(--primary-color);
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option:has(input:checked) .filter-label {
  color: var(--primary-color);
  font-weight: 600;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container {
  margin-top: 15px;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  background: #fff;
  font-size: 14px;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown:hover {
  border-color: #adb5bd;
}
.detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown option {
  padding: 8px;
  color: #495057;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #dee2e6;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn {
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid;
  min-width: 100px;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn.cancel-btn {
  background: #fff;
  color: #6c757d;
  border-color: #6c757d;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn.cancel-btn:hover {
  background: #6c757d;
  color: #fff;
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn.export-btn-primary {
  background: var(--primary-color);
  color: #fff;
  border-color: var(--primary-color);
}
.detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn.export-btn-primary:active {
  transform: translateY(1px);
}
@media (max-width: 768px) {
  .detailsection-dashboard-wrapper .invoice-export-modal {
    min-width: auto;
    width: 90vw;
    max-width: 500px;
    padding: 20px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section {
    padding: 15px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options {
    grid-template-columns: 1fr;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .month-dropdown-container .month-dropdown {
    font-size: 13px;
    padding: 8px 10px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .export-actions {
    flex-direction: column;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .export-actions .export-btn {
    width: 100%;
    min-width: auto;
  }
}
@media (max-width: 480px) {
  .detailsection-dashboard-wrapper .invoice-export-modal {
    width: 95vw;
    padding: 15px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal h3 {
    font-size: 20px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections {
    gap: 20px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section {
    padding: 12px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-title {
    font-size: 14px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option {
    padding: 6px 8px;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .filter-sections .filter-section .filter-options .filter-option .filter-label {
    font-size: 13px;
  }
}
.detailsection-dashboard-wrapper .common-modal-content:has(.pdf-export-modal) {
  border-radius: 8px !important;
  background: transparent !important;
  box-shadow: none !important;
}
.detailsection-dashboard-wrapper .pdf-export-modal {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  margin: -2rem;
  border-radius: 8px !important;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 26px;
  text-align: center;
  color: #333;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8f9fa;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-option {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 0;
  margin-bottom: 8px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-option input[type=radio] {
  margin: 0;
  cursor: pointer;
  accent-color: var(--primary-color);
  width: 18px;
  height: 18px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-option span {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  cursor: pointer;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-option input[type=radio]:checked + span {
  color: var(--primary-color);
  font-weight: 700;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-orientation .orientation-options .orientation-option-wrapper .orientation-description {
  margin: 0 0 0 30px;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
  font-weight: 400;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 25px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-export {
  padding: 8px 16px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-export:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.detailsection-dashboard-wrapper .pdf-export-modal .export-modal-actions .btn-export:not(:disabled):hover {
  opacity: 0.9;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  flex-wrap: wrap;
  gap: 10px;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .new-case-btn {
  background-color: var(--primary-color);
  color: var(--text-color);
  border: none;
  padding: 8px 18px;
  border-radius: 0.5rem;
  cursor: pointer;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-search-input {
  flex: 1 1;
  max-width: 200px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-search-input:focus {
  border-color: #ccc;
  outline: none;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons {
  display: flex;
  gap: 10px;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons .detailsection-export-btn,
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons .detailsection-import-btn {
  padding: 8px 18px;
  border: 1px solid #ccc;
  background-color: var(--primary-background-color);
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons .detailsection-export-btn .detailsection-impexpicon,
.detailsection-dashboard-wrapper .detailsection-dashboard-header .detailsection-right-buttons .detailsection-import-btn .detailsection-impexpicon {
  width: 18px;
  height: 16px;
  margin-right: 10px;
}
.detailsection-dashboard-wrapper .detailsection-dashboard-cards {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}

.pdf-export-modal,
.invoice-export-modal {
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 768px) {
  .detailsection-dashboard-wrapper .detailsection-dashboard-cards {
    display: none;
  }
  .detailsection-dashboard-wrapper .pdf-export-modal,
  .detailsection-dashboard-wrapper .invoice-export-modal {
    min-width: auto;
    width: 90vw;
    max-width: 400px;
    padding: 20px;
  }
  .detailsection-dashboard-wrapper .pdf-export-modal .export-options,
  .detailsection-dashboard-wrapper .invoice-export-modal .export-options {
    flex-direction: column;
    gap: 12px;
  }
  .detailsection-dashboard-wrapper .pdf-export-modal .export-options .export-option-btn,
  .detailsection-dashboard-wrapper .invoice-export-modal .export-options .export-option-btn {
    min-width: auto;
    width: 100%;
  }
  .detailsection-dashboard-wrapper .invoice-export-modal .export-options {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 600px) {
  .detailsection-dashboard-wrapper .pdf-export-modal .export-options .export-option-btn,
  .detailsection-dashboard-wrapper .invoice-export-modal .export-options .export-option-btn {
    padding: 15px 20px;
    min-height: 50px;
  }
}
.user-limit-modal {
  text-align: center;
  min-width: 400px;
}
.user-limit-modal .limit-icon {
  font-size: 48px;
  margin-bottom: 20px;
  display: block;
}
.user-limit-modal h3 {
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 700;
  color: #e74c3c;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.user-limit-modal .limit-message {
  margin: 0 0 30px 0;
  font-size: 16px;
  color: #555;
  line-height: 1.5;
  font-weight: 400;
}
.user-limit-modal .limit-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 35px;
}
.user-limit-modal .limit-options .limit-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  border: 1px solid #dee2e6;
  text-align: left;
  transition: all 0.3s ease;
}
.user-limit-modal .limit-options .limit-option.clickable {
  cursor: pointer;
}
.user-limit-modal .limit-options .limit-option.clickable:hover {
  background: linear-gradient(135deg, #dee2e6 0%, #ced4da 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}
.user-limit-modal .limit-options .limit-option.clickable:active {
  transform: translateY(0);
}
.user-limit-modal .limit-options .limit-option .option-icon {
  font-size: 20px;
  flex-shrink: 0;
}
.user-limit-modal .limit-options .limit-option span:not(.option-icon) {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}
.user-limit-modal .limit-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 25px;
}
.user-limit-modal .limit-actions .limit-btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 120px;
}
.user-limit-modal .limit-actions .limit-btn.secondary {
  background: #6c757d;
  color: white;
}
.user-limit-modal .limit-actions .limit-btn.secondary:hover {
  background: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}
.user-limit-modal .limit-actions .limit-btn.primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.user-limit-modal .limit-actions .limit-btn.primary:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004494 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}
.user-limit-modal .limit-actions .limit-btn.primary:active {
  transform: translateY(0);
}

.user-limit-modal {
  animation: limitModalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes limitModalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.import-clients-modal {
  min-width: 500px;
  max-width: 600px;
  padding: 0;
}
.import-clients-modal .import-modal-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  margin: 0;
  text-align: center;
}
.import-clients-modal .import-modal-content .upload-section {
  border: 2px dashed #d0d0d0;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  background: #fafafa;
  margin-bottom: 25px;
  transition: all 0.3s ease;
}
.import-clients-modal .import-modal-content .upload-section:hover {
  border-color: var(--primary-color);
  background: #f5f9ff;
}
.import-clients-modal .import-modal-content .upload-section .upload-icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
.import-clients-modal .import-modal-content .upload-section .upload-icon-container .upload-icon {
  color: var(--primary-color);
}
.import-clients-modal .import-modal-content .upload-section .upload-text {
  color: #666;
  font-size: 0.95rem;
  margin-bottom: 20px;
  line-height: 1.6;
}
.import-clients-modal .import-modal-content .upload-section .browse-btn {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
}
.import-clients-modal .import-modal-content .upload-section .browse-btn:hover {
  background: #1565c0;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);
}
.import-clients-modal .import-modal-content .modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn {
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn svg {
  width: 18px;
  height: 18px;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.download-btn {
  background: transparent;
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  margin-right: auto;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.download-btn:hover {
  background: #e3f2fd;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.close-btn {
  background: #e0e0e0;
  color: #333;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.close-btn:hover {
  background: #d0d0d0;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.submit-btn {
  background: #1976d2;
  color: white;
}
.import-clients-modal .import-modal-content .modal-actions .action-btn.submit-btn:hover {
  background: #1565c0;
  box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);
}

@media (max-width: 768px) {
  .import-clients-modal {
    min-width: auto;
    width: 90vw;
  }
  .import-clients-modal .import-modal-content {
    padding: 20px;
  }
  .import-clients-modal .import-modal-content .upload-section {
    padding: 30px 20px;
  }
  .import-clients-modal .import-modal-content .modal-actions {
    flex-wrap: wrap;
  }
  .import-clients-modal .import-modal-content .modal-actions .action-btn.download-btn {
    width: 100%;
    margin-right: 0;
    justify-content: center;
  }
  .import-clients-modal .import-modal-content .modal-actions .action-btn.close-btn, .import-clients-modal .import-modal-content .modal-actions .action-btn.submit-btn {
    flex: 1 1;
  }
  .user-limit-modal {
    min-width: auto;
    width: 90vw;
    max-width: 400px;
    padding: 30px 20px;
  }
  .user-limit-modal .limit-actions {
    flex-direction: column;
  }
  .user-limit-modal .limit-actions .limit-btn {
    width: 100%;
    min-width: auto;
  }
  .user-limit-modal .limit-options .limit-option {
    padding: 12px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DetailSection/DetailSection.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,eAAA;EACA,sBAAA;AACJ;AAEE;EACE,kBAAA;EACA,sBAAA;AAAJ;AAGE;EACE,iBAAA;EACA,mBAAA;AADJ;AAIE;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAHJ;AAKI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AAHN;AAKM;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;AAHR;AAMM;EACE,gBAAA;EACA,iBAAA;AAJR;AAQI;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;AANN;AAUE;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AARJ;AAUI;EACE,SAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;AARN;AAUM;EACE,mBAAA;EACA,WAAA;AARR;AAUQ;EACE,mBAAA;AARV;AAYM;EACE,mBAAA;EACA,YAAA;AAVR;AAYQ;EACE,mBAAA;AAVV;;AAiBC;EACC,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAdF;AAgBE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAdJ;AAgBI;EACE,gBAAA;AAdN;AAiBI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAfN;AAkBI;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAhBN;;AAqBA;EACE,aAAA;AAlBF;AAoBA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAlBF;AAoBE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,YAAA;EACA,kBAAA;AArBJ;AAuBI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AArBN;AAuBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AArBR;AAwBM;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAtBR;AA0BQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;AAxBV;AA0BU;EACE,mBAAA;EACA,qBAAA;AAxBZ;AA2BU;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,eAAA;AAzBZ;AA4BU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AA1BZ;AA6BU;EACE,mBAAA;EACA,kCAAA;AA3BZ;AA6BY;EACE,2BAAA;EACA,gBAAA;AA3Bd;AAiCM;EACE,gBAAA;AA/BR;AAiCQ;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AA/BV;AAiCU;EACE,aAAA;EACA,kCAAA;EACA,6CAAA;AA/BZ;AAkCU;EACE,qBAAA;AAhCZ;AAmCU;EACE,YAAA;EACA,cAAA;AAjCZ;AAwCE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EAEA,iBAAA;EACA,6BAAA;AAvCJ;AAyCI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAvCN;AAyCM;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAvCR;AAyCQ;EACE,mBAAA;EACA,WAAA;AAvCV;AA2CM;EACE,gCAAA;EACA,WAAA;EACA,kCAAA;AAzCR;AAgDQ;EACE,0BAAA;AA9CV;AAsDA;EACE;IACE,eAAA;IACA,WAAA;IACA,gBAAA;IACA,aAAA;EApDF;EAuDI;IACE,aAAA;EArDN;EAuDM;IACE,0BAAA;EArDR;EAwDM;IACE,eAAA;IACA,iBAAA;EAtDR;EA2DE;IACE,sBAAA;EAzDJ;EA2DI;IACE,WAAA;IACA,eAAA;EAzDN;AACF;AA8DA;EACE;IACE,WAAA;IACA,aAAA;EA5DF;EA8DE;IACE,eAAA;EA5DJ;EA+DE;IACE,SAAA;EA7DJ;EA+DI;IACE,aAAA;EA7DN;EA+DM;IACE,eAAA;EA7DR;EAgEM;IACE,gBAAA;EA9DR;EAgEQ;IACE,eAAA;EA9DV;AACF;AAsEA;EACE,6BAAA;EACA,kCAAA;EACA,2BAAA;AApEF;AAuEE;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,aAAA;EACA,6BAAA;AArEJ;AAuEI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AArEN;AAyEI;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAvEN;AAyEM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAvER;AA0EU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAxEZ;AA0EY;EACE,SAAA;EACA,eAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;AAxEd;AA2EY;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AAzEd;AA4EY;EACE,2BAAA;EACA,gBAAA;AA1Ed;AA8EU;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AA5EZ;AAkFI;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAhFN;AAkFM;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAhFR;AAkFQ;EACE,yBAAA;AAhFV;AAoFM;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAlFR;AAoFQ;EACE,sBAAA;EACA,mBAAA;AAlFV;AAqFQ;EACE,YAAA;AAnFV;AAyFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAvFJ;AAyFI;EACE,sCAAA;EACA,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;AAvFN;AA0FI;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAxFN;AA0FM;EACE,kBAAA;EACA,aAAA;AAxFR;AA4FI;EACE,aAAA;EACA,SAAA;AA1FN;AA4FM;;EAEE,iBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA1FR;AA4FQ;;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAzFV;AA+FE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AA7FJ;;AAiGA;;EAEE,qCAAA;AA9FF;;AAiGA;EACE;IACE,UAAA;IACA,wCAAA;EA9FF;EAiGA;IACE,UAAA;IACA,iCAAA;EA/FF;AACF;AAkGA;EAEI;IACE,aAAA;EAjGJ;EAoGE;;IAEE,eAAA;IACA,WAAA;IACA,gBAAA;IACA,aAAA;EAlGJ;EAoGI;;IACE,sBAAA;IACA,SAAA;EAjGN;EAmGM;;IACE,eAAA;IACA,WAAA;EAhGR;EAqGE;IACE,0BAAA;EAnGJ;AACF;AAuGA;EAKQ;;IACE,kBAAA;IACA,gBAAA;EAxGR;AACF;AAgHA;EACE,kBAAA;EACA,gBAAA;AA9GF;AAgHE;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AA9GJ;AAiHE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yCAAA;AA/GJ;AAkHE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAhHJ;AAmHE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAjHJ;AAmHI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;AAjHN;AAmHM;EACE,eAAA;AAjHR;AAmHQ;EACE,6DAAA;EACA,2BAAA;EACA,0CAAA;AAjHV;AAoHQ;EACE,wBAAA;AAlHV;AAsHM;EACE,eAAA;EACA,cAAA;AApHR;AAuHM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AArHR;AA0HE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;AAxHJ;AA0HI;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;AAxHN;AA0HM;EACE,mBAAA;EACA,YAAA;AAxHR;AA0HQ;EACE,mBAAA;EACA,2BAAA;EACA,+CAAA;AAxHV;AA4HM;EACE,6DAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA1HR;AA4HQ;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;AA1HV;AA6HQ;EACE,wBAAA;AA3HV;;AAkIA;EACE,mEAAA;AA/HF;;AAkIA;EACE;IACE,UAAA;IACA,uCAAA;EA/HF;EAkIA;IACE,UAAA;IACA,iCAAA;EAhIF;AACF;AAoIA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;AAlIF;AAoIE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;AAlIJ;AAyII;EACE,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAvIN;AAyIM;EACE,kCAAA;EACA,mBAAA;AAvIR;AA0IM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAxIR;AA0IQ;EACE,2BAAA;AAxIV;AA4IM;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA1IR;AA6IM;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AA3IR;AA6IQ;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AA3IV;AAgJI;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AA9IN;AAgJM;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA9IR;AAgJQ;EACE,WAAA;EACA,YAAA;AA9IV;AAiJQ;EACE,uBAAA;EACA,2BAAA;EACA,sCAAA;EACA,kBAAA;AA/IV;AAiJU;EACE,mBAAA;AA/IZ;AAmJQ;EACE,mBAAA;EACA,WAAA;AAjJV;AAmJU;EACE,mBAAA;AAjJZ;AAqJQ;EACE,mBAAA;EACA,YAAA;AAnJV;AAqJU;EACE,mBAAA;EACA,6CAAA;AAnJZ;;AA2JA;EACE;IACE,eAAA;IACA,WAAA;EAxJF;EA0JE;IACE,aAAA;EAxJJ;EA0JI;IACE,kBAAA;EAxJN;EA2JI;IACE,eAAA;EAzJN;EA4JQ;IACE,WAAA;IACA,eAAA;IACA,uBAAA;EA1JV;EA6JQ;IAEE,SAAA;EA5JV;EAmKA;IACE,eAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;EAjKF;EAmKE;IACE,sBAAA;EAjKJ;EAmKI;IACE,WAAA;IACA,eAAA;EAjKN;EAqKE;IACE,kBAAA;EAnKJ;AACF","sourcesContent":[".compact-limit-modal {\r\n  max-width: 380px;\r\n\r\n  .limit-icon {\r\n    font-size: 2rem;\r\n    margin-bottom: 0.75rem;\r\n  }\r\n\r\n  h3 {\r\n    font-size: 1.25rem;\r\n    margin-bottom: 0.75rem;\r\n  }\r\n\r\n  .limit-message {\r\n    font-size: 0.9rem;\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  .limit-message-small {\r\n    font-size: 0.85rem;\r\n    margin-top: 0.75rem;\r\n    margin-bottom: 1rem;\r\n    opacity: 0.8;\r\n  }\r\n\r\n  .limit-stats-compact {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.75rem;\r\n    padding: 0.75rem;\r\n    background: #f5f5f5;\r\n    border-radius: 6px;\r\n    font-size: 0.9rem;\r\n\r\n    .stat-item {\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      gap: 0.25rem;\r\n\r\n      .stat-label {\r\n        font-size: 0.75rem;\r\n        opacity: 0.7;\r\n        text-transform: uppercase;\r\n      }\r\n\r\n      .stat-value {\r\n        font-weight: 600;\r\n        font-size: 1.1rem;\r\n      }\r\n    }\r\n\r\n    .stat-divider {\r\n      font-size: 1.25rem;\r\n      opacity: 0.3;\r\n      margin: 0 0.25rem;\r\n    }\r\n  }\r\n\r\n  .limit-actions-compact {\r\n    display: flex;\r\n    gap: 0.75rem;\r\n    margin-top: 1rem;\r\n\r\n    .limit-btn {\r\n      flex: 1;\r\n      padding: 0.5rem 1rem;\r\n      font-size: 0.9rem;\r\n      border-radius: 6px;\r\n      border: none;\r\n      cursor: pointer;\r\n      transition: all 0.2s;\r\n\r\n      &.secondary {\r\n        background: #e0e0e0;\r\n        color: #333;\r\n\r\n        &:hover {\r\n          background: #d0d0d0;\r\n        }\r\n      }\r\n\r\n      &.primary {\r\n        background: #1976d2;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #1565c0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n} \r\n \r\n .date-range-inputs {\r\n  display: block !important;\r\n  margin-top: 15px;\r\n  padding: 15px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 5px;\r\n  background-color: #f9f9f9;\r\n\r\n  .date-input-group {\r\n    margin-bottom: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    label {\r\n      min-width: 80px;\r\n      font-weight: 500;\r\n      color: #333;\r\n    }\r\n\r\n    input[type=\"date\"] {\r\n      padding: 8px 12px;\r\n      border: 1px solid #ccc;\r\n      border-radius: 4px;\r\n      font-size: 14px;\r\n      flex: 1;\r\n    }\r\n  }\r\n}\r\n\r\n.detailsection-dashboard-wrapper {\r\n  padding: 10px;\r\n\r\n.invoice-export-modal {\r\n  padding: 0px;\r\n  text-align: left;\r\n  min-width: 500px;\r\n  max-width: 600px;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n\r\n  h3 {\r\n    margin: 0 0 8px 0;\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n    color: #333;\r\n    text-align: center;\r\n  }\r\n\r\n  .export-subtext {\r\n    margin: 0 0 25px 0;\r\n    font-size: 14px;\r\n    color: #666;\r\n    line-height: 1.4;\r\n    text-align: center;\r\n  }\r\n\r\n  .filter-sections {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    // margin-bottom: 30px;\r\n    height: 60vh;\r\n    overflow-y: scroll;\r\n\r\n    .filter-section {\r\n      border: 1px solid #e9ecef;\r\n      border-radius: 8px;\r\n      padding: 20px;\r\n      background: #f8f9fa;\r\n\r\n      .filter-title {\r\n        margin: 0 0 15px 0;\r\n        font-size: 16px;\r\n        font-weight: 600;\r\n        color: #495057;\r\n        border-bottom: 2px solid #dee2e6;\r\n        padding-bottom: 8px;\r\n      }\r\n\r\n      .filter-options {\r\n        display: grid;\r\n        grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\r\n        gap: 12px;\r\n\r\n\r\n\r\n        .filter-option {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 8px;\r\n          cursor: pointer;\r\n          padding: 8px 12px;\r\n          border-radius: 6px;\r\n          transition: all 0.2s ease;\r\n          border: 1px solid transparent;\r\n\r\n          &:hover {\r\n            background: #e9ecef;\r\n            border-color: #ced4da;\r\n          }\r\n\r\n          input[type=\"radio\"] {\r\n            margin: 0;\r\n            width: 16px;\r\n            height: 16px;\r\n            accent-color: var(--primary-color);\r\n            cursor: pointer;\r\n          }\r\n\r\n          .filter-label {\r\n            font-size: 14px;\r\n            color: #495057;\r\n            font-weight: 500;\r\n            cursor: pointer;\r\n            user-select: none;\r\n          }\r\n\r\n          &:has(input:checked) {\r\n            background: #e7f3ff;\r\n            border-color: var(--primary-color);\r\n            \r\n            .filter-label {\r\n              color: var(--primary-color);\r\n              font-weight: 600;\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .month-dropdown-container {\r\n        margin-top: 15px;\r\n        \r\n        .month-dropdown {\r\n          width: 100%;\r\n          padding: 10px 12px;\r\n          border: 1px solid #ced4da;\r\n          border-radius: 6px;\r\n          background: #fff;\r\n          font-size: 14px;\r\n          color: #495057;\r\n          cursor: pointer;\r\n          transition: all 0.2s ease;\r\n          \r\n          &:focus {\r\n            outline: none;\r\n            border-color: var(--primary-color);\r\n            box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\r\n          }\r\n          \r\n          &:hover {\r\n            border-color: #adb5bd;\r\n          }\r\n          \r\n          option {\r\n            padding: 8px;\r\n            color: #495057;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .export-actions {\r\n    display: flex;\r\n    gap: 12px;\r\n    justify-content: flex-end;\r\n    // margin-top: 25px;\r\n    padding-top: 20px;\r\n    border-top: 1px solid #dee2e6;\r\n\r\n    .export-btn {\r\n      padding: 8px 18px;\r\n      border-radius: 6px;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      transition: all 0.2s ease;\r\n      border: 1px solid;\r\n      min-width: 100px;\r\n      \r\n      &.cancel-btn {\r\n        background: #fff;\r\n        color: #6c757d;\r\n        border-color: #6c757d;\r\n\r\n        &:hover {\r\n          background: #6c757d;\r\n          color: #fff;\r\n        }\r\n      }\r\n\r\n      &.export-btn-primary {\r\n        background: var(--primary-color);\r\n        color: #fff;\r\n        border-color: var(--primary-color);\r\n\r\n        // &:hover {\r\n        //   background: #0056b3;\r\n        //   border-color: #0056b3;\r\n        // }\r\n\r\n        &:active {\r\n          transform: translateY(1px);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive design\r\n@media (max-width: 768px) {\r\n  .invoice-export-modal {\r\n    min-width: auto;\r\n    width: 90vw;\r\n    max-width: 500px;\r\n    padding: 20px;\r\n\r\n    .filter-sections {\r\n      .filter-section {\r\n        padding: 15px;\r\n\r\n        .filter-options {\r\n          grid-template-columns: 1fr;\r\n        }\r\n        \r\n        .month-dropdown-container .month-dropdown {\r\n          font-size: 13px;\r\n          padding: 8px 10px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .export-actions {\r\n      flex-direction: column;\r\n      \r\n      .export-btn {\r\n        width: 100%;\r\n        min-width: auto;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .invoice-export-modal {\r\n    width: 95vw;\r\n    padding: 15px;\r\n    \r\n    h3 {\r\n      font-size: 20px;\r\n    }\r\n\r\n    .filter-sections {\r\n      gap: 20px;\r\n      \r\n      .filter-section {\r\n        padding: 12px;\r\n        \r\n        .filter-title {\r\n          font-size: 14px;\r\n        }\r\n        \r\n        .filter-options .filter-option {\r\n          padding: 6px 8px;\r\n          \r\n          .filter-label {\r\n            font-size: 13px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Override CommonModal styling for PDF export modal\r\n.common-modal-content:has(.pdf-export-modal) {\r\n  border-radius: 8px !important;\r\n  background: transparent !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n  .pdf-export-modal {\r\n    background: white;\r\n    border-radius: 8px;\r\n    padding: 24px;\r\n    width: 90%;\r\n    max-width: 800px;\r\n    max-height: 90vh;\r\n    overflow-y: auto;\r\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n    margin: -2rem; // Counteract CommonModal's padding\r\n    border-radius: 8px !important; // Override CommonModal's border-radius\r\n\r\n    .export-modal-title {\r\n      font-size: 18px;\r\n      font-weight: 600;\r\n      margin-bottom: 26px;\r\n      text-align: center;\r\n      color: #333;\r\n    }\r\n\r\n    // Orientation Selection Styles\r\n    .export-modal-orientation {\r\n      margin-top: 20px;\r\n      padding: 20px;\r\n      border: 1px solid #e2e8f0;\r\n      border-radius: 8px;\r\n      background-color: #f8f9fa;\r\n\r\n      .orientation-options {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 20px;\r\n\r\n        .orientation-option-wrapper {\r\n          .orientation-option {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 12px;\r\n            cursor: pointer;\r\n            padding: 0;\r\n            margin-bottom: 8px;\r\n\r\n            input[type=\"radio\"] {\r\n              margin: 0;\r\n              cursor: pointer;\r\n              accent-color: var(--primary-color);\r\n              width: 18px;\r\n              height: 18px;\r\n            }\r\n\r\n            span {\r\n              font-size: 16px;\r\n              color: #333;\r\n              font-weight: 600;\r\n              cursor: pointer;\r\n            }\r\n\r\n            input[type=\"radio\"]:checked + span {\r\n              color: var(--primary-color);\r\n              font-weight: 700;\r\n            }\r\n          }\r\n\r\n          .orientation-description {\r\n            margin: 0 0 0 30px;\r\n            font-size: 14px;\r\n            color: #666;\r\n            line-height: 1.4;\r\n            font-weight: 400;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .export-modal-actions {\r\n      display: flex;\r\n      justify-content: flex-end;\r\n      gap: 12px;\r\n      margin-top: 25px;\r\n\r\n      .btn-cancel {\r\n        padding: 8px 16px;\r\n        border: 1px solid #ddd;\r\n        background: white;\r\n        color: #666;\r\n        border-radius: 4px;\r\n        cursor: pointer;\r\n        font-size: 14px;\r\n\r\n        &:hover {\r\n          background-color: #f8f9fa;\r\n        }\r\n      }\r\n\r\n      .btn-export {\r\n        padding: 8px 16px;\r\n        background: var(--primary-color);\r\n        color: white;\r\n        border: none;\r\n        border-radius: 4px;\r\n        cursor: pointer;\r\n        font-size: 14px;\r\n\r\n        &:disabled {\r\n          background-color: #ccc;\r\n          cursor: not-allowed;\r\n        }\r\n\r\n        &:not(:disabled):hover {\r\n          opacity: 0.9;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .detailsection-dashboard-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 5px;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n\r\n    .new-case-btn {\r\n      background-color: var(--primary-color);\r\n      color: var(--text-color);\r\n      border: none;\r\n      padding: 8px 18px;\r\n      border-radius: 0.5rem;\r\n      cursor: pointer;\r\n    }\r\n\r\n    .detailsection-search-input {\r\n      flex: 1;\r\n      max-width: 200px;\r\n      padding: 8px;\r\n      border: 1px solid #ccc;\r\n      border-radius: 6px;\r\n\r\n      &:focus {\r\n        border-color: #ccc;\r\n        outline: none;\r\n      }\r\n    }\r\n\r\n    .detailsection-right-buttons {\r\n      display: flex;\r\n      gap: 10px;\r\n\r\n      .detailsection-export-btn,\r\n      .detailsection-import-btn {\r\n        padding: 8px 18px;\r\n        border: 1px solid #ccc;\r\n        background-color: var(--primary-background-color);\r\n        border-radius: 6px;\r\n        cursor: pointer;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        .detailsection-impexpicon {\r\n          width: 18px;\r\n          height: 16px;\r\n          margin-right: 10px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .detailsection-dashboard-cards {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    margin-top: 10px;\r\n  }\r\n}\r\n\r\n.pdf-export-modal,\r\n.invoice-export-modal {\r\n  animation: modalSlideIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes modalSlideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-20px) scale(0.95);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .detailsection-dashboard-wrapper {\r\n    .detailsection-dashboard-cards {\r\n      display: none;\r\n    }\r\n\r\n    .pdf-export-modal,\r\n    .invoice-export-modal {\r\n      min-width: auto;\r\n      width: 90vw;\r\n      max-width: 400px;\r\n      padding: 20px;\r\n\r\n      .export-options {\r\n        flex-direction: column;\r\n        gap: 12px;\r\n\r\n        .export-option-btn {\r\n          min-width: auto;\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n\r\n    .invoice-export-modal .export-options {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .detailsection-dashboard-wrapper {\r\n    .pdf-export-modal,\r\n    .invoice-export-modal {\r\n      .export-options {\r\n        .export-option-btn {\r\n          padding: 15px 20px;\r\n          min-height: 50px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Add this to your DetailSection.scss file\r\n\r\n.user-limit-modal {\r\n  text-align: center;\r\n  min-width: 400px;\r\n\r\n  .limit-icon {\r\n    font-size: 48px;\r\n    margin-bottom: 20px;\r\n    display: block;\r\n  }\r\n\r\n  h3 {\r\n    margin: 0 0 16px 0;\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    color: #e74c3c;\r\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .limit-message {\r\n    margin: 0 0 30px 0;\r\n    font-size: 16px;\r\n    color: #555;\r\n    line-height: 1.5;\r\n    font-weight: 400;\r\n  }\r\n\r\n  .limit-options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n    margin-bottom: 35px;\r\n\r\n    .limit-option {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 12px;\r\n      padding: 16px 20px;\r\n      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\r\n      border-radius: 10px;\r\n      border: 1px solid #dee2e6;\r\n      text-align: left;\r\n      transition: all 0.3s ease;\r\n\r\n      &.clickable {\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n          background: linear-gradient(135deg, #dee2e6 0%, #ced4da 100%);\r\n          transform: translateY(-2px);\r\n          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\r\n        }\r\n\r\n        &:active {\r\n          transform: translateY(0);\r\n        }\r\n      }\r\n\r\n      .option-icon {\r\n        font-size: 20px;\r\n        flex-shrink: 0;\r\n      }\r\n\r\n      span:not(.option-icon) {\r\n        font-size: 15px;\r\n        font-weight: 500;\r\n        color: #333;\r\n      }\r\n    }\r\n  }\r\n\r\n  .limit-actions {\r\n    display: flex;\r\n    gap: 12px;\r\n    justify-content: center;\r\n    margin-top: 25px;\r\n\r\n    .limit-btn {\r\n      padding: 12px 24px;\r\n      border-radius: 8px;\r\n      font-size: 14px;\r\n      font-weight: 600;\r\n      text-decoration: none;\r\n      cursor: pointer;\r\n      transition: all 0.3s ease;\r\n      border: none;\r\n      min-width: 120px;\r\n\r\n      &.secondary {\r\n        background: #6c757d;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #5a6268;\r\n          transform: translateY(-1px);\r\n          box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\r\n        }\r\n      }\r\n\r\n      &.primary {\r\n        background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\r\n        color: white;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        &:hover {\r\n          background: linear-gradient(135deg, #0056b3 0%, #004494 100%);\r\n          transform: translateY(-2px);\r\n          box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);\r\n        }\r\n\r\n        &:active {\r\n          transform: translateY(0);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.user-limit-modal {\r\n  animation: limitModalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\r\n}\r\n\r\n@keyframes limitModalSlideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-30px) scale(0.9);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n// Import Clients Modal Styles\r\n.import-clients-modal {\r\n  min-width: 500px;\r\n  max-width: 600px;\r\n  padding: 0;\r\n\r\n  .import-modal-title {\r\n    font-size: 1.3rem;\r\n    font-weight: 600;\r\n    color: #333;\r\n    margin: 0;\r\n    text-align: center;\r\n  }\r\n\r\n  .import-modal-content {\r\n    // padding: 30px;\r\n    // padding-top: 0px;\r\n\r\n    .upload-section {\r\n      border: 2px dashed #d0d0d0;\r\n      border-radius: 8px;\r\n      padding: 40px;\r\n      text-align: center;\r\n      background: #fafafa;\r\n      margin-bottom: 25px;\r\n      transition: all 0.3s ease;\r\n\r\n      &:hover {\r\n        border-color: var(--primary-color);\r\n        background: #f5f9ff;\r\n      }\r\n\r\n      .upload-icon-container {\r\n        display: flex;\r\n        justify-content: center;\r\n        margin-bottom: 15px;\r\n\r\n        .upload-icon {\r\n          color: var(--primary-color);\r\n        }\r\n      }\r\n\r\n      .upload-text {\r\n        color: #666;\r\n        font-size: 0.95rem;\r\n        margin-bottom: 20px;\r\n        line-height: 1.6;\r\n      }\r\n\r\n      .browse-btn {\r\n        background: var(--primary-color);\r\n        color: white;\r\n        border: none;\r\n        padding: 10px 24px;\r\n        border-radius: 6px;\r\n        font-size: 0.95rem;\r\n        cursor: pointer;\r\n        transition: all 0.2s;\r\n\r\n        &:hover {\r\n          background: #1565c0;\r\n          transform: translateY(-1px);\r\n          box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);\r\n        }\r\n      }\r\n    }\r\n\r\n    .modal-actions {\r\n      display: flex;\r\n      gap: 12px;\r\n      justify-content: flex-end;\r\n\r\n      .action-btn {\r\n        padding: 10px 20px;\r\n        border-radius: 6px;\r\n        border: none;\r\n        font-size: 0.95rem;\r\n        cursor: pointer;\r\n        transition: all 0.2s;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n\r\n        svg {\r\n          width: 18px;\r\n          height: 18px;\r\n        }\r\n\r\n        &.download-btn {\r\n          background: transparent;\r\n          color: var(--primary-color);\r\n          border: 1px solid var(--primary-color);\r\n          margin-right: auto;\r\n\r\n          &:hover {\r\n            background: #e3f2fd;\r\n          }\r\n        }\r\n\r\n        &.close-btn {\r\n          background: #e0e0e0;\r\n          color: #333;\r\n\r\n          &:hover {\r\n            background: #d0d0d0;\r\n          }\r\n        }\r\n\r\n        &.submit-btn {\r\n          background: #1976d2;\r\n          color: white;\r\n\r\n          &:hover {\r\n            background: #1565c0;\r\n            box-shadow: 0 4px 8px rgba(25, 118, 210, 0.3);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .import-clients-modal {\r\n    min-width: auto;\r\n    width: 90vw;\r\n\r\n    .import-modal-content {\r\n      padding: 20px;\r\n\r\n      .upload-section {\r\n        padding: 30px 20px;\r\n      }\r\n\r\n      .modal-actions {\r\n        flex-wrap: wrap;\r\n\r\n        .action-btn {\r\n          &.download-btn {\r\n            width: 100%;\r\n            margin-right: 0;\r\n            justify-content: center;\r\n          }\r\n\r\n          &.close-btn,\r\n          &.submit-btn {\r\n            flex: 1;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .user-limit-modal {\r\n    min-width: auto;\r\n    width: 90vw;\r\n    max-width: 400px;\r\n    padding: 30px 20px;\r\n\r\n    .limit-actions {\r\n      flex-direction: column;\r\n\r\n      .limit-btn {\r\n        width: 100%;\r\n        min-width: auto;\r\n      }\r\n    }\r\n\r\n    .limit-options .limit-option {\r\n      padding: 12px 16px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
